<template>
    <div v-if="GET_LOG_ENTRIES.length > 0">
        <b-pagination
            align="right"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="my-table"
            :hide-goto-end-buttons="true"
            :limit="3"
        ></b-pagination>
        <b-table hover small
            :per-page="perPage"
            :fields="fields"
            :items="GET_LOG_ENTRIES"
            :sort-icon-left="true"
            class="table-responsive-sm"
        >
            <template v-slot:cell(json_change_message)="row">
                <span>{{ translateMessage(row.item) }}</span>
            </template>
        </b-table>
    </div>
    <div v-else class="text-center full-width py-3">
        <hr>
        <h4>{{ $i18n.t('reports.no-data') }}</h4>
    </div>
</template>

<script>
    // vuex
    import {mapActions, mapGetters} from "vuex";
    import {
        GET_LOG_ENTRIES,
        GET_TOTAL_ENTRIES,
        GET_PAGINATION_PAGE,
        SET_PAGINATION_PAGE
    } from "../../store/actions/reports";
    // utils
    import {
        formatDate,
        parsedDate,
        compileAndTranslateChangeMessage
    } from "../../utils/common";

    export default {
        name: "AuditsTable",
        data() {
            return {
                error: false,
                perPage: 30,   // same on BE
                fields: [
                    {
                        key: 'action_time',
                        label: this.$i18n.t('reports.table.date'),
                        sortable: true,
                        formatter:(value) => {
                            return this.dateFormatter(parsedDate(value));
                        }
                    },
                    {
                        key: 'object_repr',
                        label: this.$i18n.t('reports.table.site-user'),
                        sortable: true,
                    },
                    {
                        key: 'username',
                        label: this.$i18n.t('reports.table.username'),
                        sortable: true
                    },
                    {
                        key: 'json_change_message',
                        label: this.$i18n.t('reports.table.action'),
                        sortable: true
                    }
                ]
            }
        },
        methods: {
            ...mapActions([SET_PAGINATION_PAGE]),
            dateFormatter(date) {
                return formatDate(new Date(date));
            },
            translateMessage(message) {
                return compileAndTranslateChangeMessage(message);
            }
        },
        computed: {
            ...mapGetters([GET_LOG_ENTRIES, GET_TOTAL_ENTRIES, GET_PAGINATION_PAGE]),
            /**
             * Computes how many rows the table has.
             * Used by pagination.
             * @returns {number}
             */
            rows() {
                return this.GET_TOTAL_ENTRIES;
            },
            currentPage: {
                get: function () {
                    return this.GET_PAGINATION_PAGE;
                },
                set: function(newPage) {
                    this.SET_PAGINATION_PAGE(newPage);
                    this.$emit('do-query', newPage);
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/variables";
</style>